import React, { useState, useEffect } from "react";
import "../../../styles/dashboardPagesStyle/Charts.css";
import { Info } from "lucide-react";
import type { UnidadeCidade } from "../../../API/dashboardPageService";

interface EstoqueDataItem {
  cidade: string;
  vendidos: number;
  disponiveis: number;
}

interface Props {
  unidadesCidade: { [cidade: string]: UnidadeCidade } | null;
}

export default function EstoqueCidadeChart({ unidadesCidade }: Props) {
  const [estoqueData, setEstoqueData] = useState<EstoqueDataItem[]>([]);
  const [popup, setPopup] = useState({ visible: false, text: "" });

  useEffect(() => {
    if (unidadesCidade) {
      const formatted = Object.entries(unidadesCidade).map(([cidade, valores]) => ({
        cidade,
        vendidos: valores.vendidas,
        disponiveis: valores.disponivel_ou_distrato,
      }));
      setEstoqueData(formatted);
    }
  }, [unidadesCidade]);

  const handleInfoClick = () => {
    setPopup({
      visible: true,
      text: "Este gráfico mostra o número de unidades vendidas e disponíveis por localidade.",
    });
  };

  return (
    <div className="card-grafico-cidade info-card">
      <h3>Estoque por localidade</h3>
      <Info className="info-btn" size={20} onClick={handleInfoClick} />

      <div className="tabela-cidade">
        <div className="tabela-header">
          <span>#</span>
          <span>Localidade</span>
          <span>Vendas sobre o total</span>
          <span>Disponíveis</span>
          <span>Total</span>
        </div>

        <div className="tabela-body">
          {estoqueData.map((item, index) => {
            const total = item.vendidos + item.disponiveis;
            const vendidosPercent = total > 0 ? (item.vendidos / total) * 100 : 0;
            const disponiveisPercent = total > 0 ? (item.disponiveis / total) * 100 : 0;
            const vendidosLabel = `${Math.round(vendidosPercent)}%`;

            return (
              <div className="linha-cidade" key={index}>
                <span>{String(index + 1).padStart(2, "0")}</span>
                <span>{item.cidade}</span>

                <div className="barra-vendas-wrapper tooltip-wrapper">
                  <div className="barra-vendas">
                    <div className="vendidos" style={{ width: `${vendidosPercent}%` }} />
                    <div className="disponiveis" style={{ width: `${disponiveisPercent}%` }} />
                  </div>
                  <span className="porcentagem-label">{vendidosLabel}</span>
                  <span className="tooltip">
                    Vendidos: {item.vendidos} | Disponíveis: {item.disponiveis}
                  </span>
                </div>

                <span className="badge">{item.disponiveis}</span>
                <span className="badge total">{total}</span>
              </div>
            );
          })}
        </div>
      </div>

      {popup.visible && (
        <div className="info-popup-overlay" onClick={() => setPopup({ visible: false, text: "" })}>
          <div className="info-popup" onClick={e => e.stopPropagation()}>
            <h4>Informações</h4>
            <p>{popup.text}</p>
            <button onClick={() => setPopup({ visible: false, text: "" })}>Fechar</button>
          </div>
        </div>
      )}
    </div>
  );
}
